import React from 'react';
import type { TextShape as TextShapeType } from '../../types';

interface TextShapeProps {
  shape: TextShapeType;
  isEditor?: boolean;
  isSelected?: boolean;
}

export const TextShape = React.memo(function TextShape({ shape, isEditor, isSelected }: TextShapeProps) {
  return (
    <g data-shape-id={shape.id}>
      {/* Transparent hit area for pointer events — fill only, no extended stroke */}
      <rect
        x={shape.x}
        y={shape.y}
        width={shape.width}
        height={shape.height}
        fill="transparent"
        stroke="none"
        pointerEvents={isEditor ? 'fill' : 'none'}
        style={isEditor ? { cursor: 'inherit' } : undefined}
      />
      {/* Dotted border only while drawing (no text yet).
          Once text is committed the shape has no SVG border;
          the SelectionOutline handles the selection visual. */}
      {!shape.text && (
        <rect
          x={shape.x}
          y={shape.y}
          width={shape.width}
          height={shape.height}
          fill="none"
          stroke={shape.color}
          strokeWidth={2}
          strokeDasharray="6 4"
          vectorEffect="non-scaling-stroke"
          pointerEvents="none"
          opacity={0.8}
        />
      )}
    </g>
  );
});
